const Pending = () => {
    return ( 
        <div className="SpecificBlog">
            <div>
            <h3>Your Request has been received and is under verification</h3>
            <h4>We will send you an email when your account is verified. Be ready with your content! Thank you😊</h4>
            </div>
        </div>
     );
}
 
export default Pending;